// store/workflows/safetyFormWorkflow/slice.js

import { makeSafetyFormWorkflowActions } from "./workflowsSafetyFormWorksflowAction";

export const createSafetyFormWorkflowSlice = (set, get) => ({
  safetyFormWorkflowActions: Object.freeze(
    makeSafetyFormWorkflowActions(set, get)
  ),
});
